import React, { FC } from 'react';
import { GxButton, GxIcon } from '@garpix/garpix-web-components-react';
import ModalLayout from '../../../../components/ModalLayout';
import styles from './index.module.scss';
import { IModalExtendCertificate } from './types';
import { CertificateIcon } from '../../../../assets';

const ModalExtendCertificate: FC<IModalExtendCertificate> = (props) => {
  const { flag, onRequestClose, onSave, certificateIds } = props;
  return (
    <ModalLayout
      flag={flag}
      onClose={() => {
        onRequestClose();
      }}
    >
      <div className={styles.header}>
        <div className={styles.header__container}>
          <GxIcon className={styles.header__icon} src={CertificateIcon}/>
          <h2 className={styles.header__title}>Продление сертификата</h2>
        </div>
        <div className={styles.header__certificates}>
          Сертификаты:{' '}
          {certificateIds.map((item, index) => (
            <span key={item}>{item}{
              index !== certificateIds.length - 1 ? ', ' : ''
            }</span>
          ))}
        </div>
      </div>
      <div className={styles.main}>
        <h2 className={styles.main__title}>
          Вы уверены, что хотите продлить выбранные сертификаты на 60 дней?
        </h2>
      </div>
      <div className={styles.footer}>
        <div className={styles.footer__container}>
          <GxButton
            className={styles.btn__close}
            onClick={onRequestClose}
          >
            Отмена
          </GxButton>
          <GxButton
            className={styles.btn__save}
            type="submit"
            onClick={onSave}
          >
            Подтвердить
          </GxButton>
        </div>
      </div>
    </ModalLayout>
  );
};

export default ModalExtendCertificate;